<template>
  <div class="custom-actions">
    <div class="d-flex" v-if="rowData.approved_at === null">
      <button
        class="btn btn--only-icon-rounded btn--green "
        @click="approvePersonKpi(rowData)"
      >
        <i class="far fa-check"></i>
      </button>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
      required: true,
    },
    isVueTable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {},
  methods: {

    approvePersonKpi(rowData) {
      Vue.swal
          .fire({
            title: "Are you sure?",
            text: "You want approve this association?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!",
          })
          .then((result) => {
              if (result.value) {
                axios
                    .put("/personKpi/"+rowData.id+"/approve")
                    .then(() => location.reload());
              }
          });
    },
    
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value == null) ? '' : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    formatDateTime (value, fmt = 'D MMM YYYY HH:mm') {      
      return (value == null) ? '' : this.$moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    },
  },
};
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>
